import { Component, Prop, Vue } from 'vue-property-decorator';
import { addMinutes, differenceInMinutes, subMinutes } from 'date-fns';
import CalendarJobEntity from '@/model/entity/calendar/calendar-job';
import EventBus from '@vertical-plus/vue-js-core/dist/util/event/event-bus';
import Job from '@/model/entity/job/job';
import JobCard from '../job-card/index.vue';

@Component({
    components: {
        'app-job-card': JobCard,
    },
})
export default class CalendarJob extends Vue
{
    @Prop()
    private value!: CalendarJobEntity;

    @Prop()
    private fadeUnassignedUserId!: number;

    /**
     * Handles job preview requests
     *
     * @param job
     * @param event
     */

    private onPreviewJob(job: Job, event: any)
    {
        EventBus.instance.$emit('preview-job', job.id);
    }

    /**
     * Handles job open requests
     *
     * @param job
     * @param event
     */

    private onOpenJob(job: Job, event: any)
    {
        EventBus.instance.$emit(
            'open-job', job.id, true,
        );
    }

    /**
     * Increases the time on a job by 30 mins
     *
     * @param calendarJob
     * @param event
     */

    private onIncreaseJobTime(calendarJob: CalendarJobEntity, event: any)
    {
        event.preventDefault();

        // Update locally
        calendarJob.dateTo = addMinutes(calendarJob.dateTo, 30);

        // Update the server
        this.$serviceContainer.calendarService.updateCalendarJob(calendarJob);

        // Emit an event for listeners
        EventBus.instance.$emit('calendar-job-updated', calendarJob);
    }

    /**
     * Decreases the time on a job by 30 mins
     *
     * @param calendarJob
     * @param event
     */

    private onDecreaseJobTime(calendarJob: CalendarJobEntity, event: any)
    {
        event.preventDefault();

        // Don't allow reducing to less than 30 mins
        if (this.is30Mins)
        {
            return;
        }

        // Update locally
        calendarJob.dateTo = subMinutes(calendarJob.dateTo, 30);

        // Update the server
        this.$serviceContainer.calendarService.updateCalendarJob(calendarJob);

        // Emit an event for listeners
        EventBus.instance.$emit('calendar-job-updated', calendarJob);
    }

    /**
     * Returns whether the job is 30 mins or less
     */

    private get is30Mins(): boolean
    {
        const minutes = differenceInMinutes(this.value.dateTo, this.value.dateFrom);

        return minutes <= 30;
    }
}